import * as moment from "moment";
import { Format } from "../constants/format";

export class DateUtils {
    public static transform(dateStr?: string): Date {
        if (dateStr) {
            return moment(dateStr, Format.DATE).toDate();
        }
        return new Date();
    }

    public static format(date?: Date): string {
        if (date) {
            return moment(date).format(Format.DATE);
        }
        return '';
    }
}

export const MY_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY'
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    }
};